var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"spinner"},[_c('span',{staticClass:"spinner__icon"}),_c('span',{class:['spinner__label', !_vm.showText && 'visually-hidden']},[_vm._t("default",function(){return [_vm._v("Загрузка...")]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }